// Shared utility module — imported by webpack at build time via @xolo/shared/utility.
//
// Provides: blockUI/unblockUI, postLink (with CSRF), number formatting,
// debounce, device detection, tracking events, and other common helpers.
//
// Dependencies:
// - jQuery (external in webpack)
// - block-ui jQuery plugin (imported below)
// - window.Session must exist at runtime for initTrackingEvents (rootUrl, domain)

import './block-ui';

let Utility = {
    originalMessage: '',

    init: () => {
        Utility.stringFormat();
        Utility.initFormSubmitBlockUI();
        Utility.initTrackingEvents();

        $(document).on('click', '.hide-on-click', {time: 300}, Utility.fadeAndRemove);
    },

    initTrackingEvents: () => {
        $(document).on('click', '[data-track-event]', (event) => {
            const eventName = event.currentTarget.dataset.trackEvent || event.currentTarget.id;
            if (eventName) {
                $.post(`${Session.rootUrl}pixel/${Session.domain}/event/${eventName}`);
            }
        });
    },

    pollSmartId: (pollUrl, redirectUrl, intervalMillis, fromFail) => {
        window.setTimeout(() => {
            $.ajax({method: "GET", url: pollUrl, dataType: "text", cache: false, headers: {"cache-control": "no-cache"}})
                .done((data) => {
                    if (data === 'RUNNING') {
                        Utility.pollSmartId(pollUrl, redirectUrl, intervalMillis + 500, false);
                    } else if (data === 'SUCCESS') {
                        window.location.href = redirectUrl;
                    } else {
                        window.location.href = (redirectUrl + "?error=" + data);
                    }
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    fromFail ? window.location.href = (redirectUrl + "?error=FAILURE_TECHNICAL") : Utility.pollSmartId(pollUrl, redirectUrl, 1000, true);
                });
        }, intervalMillis);
    },

    postLink: (anchor) => {
        if (!anchor || !anchor.dataset || !anchor.dataset.href) {
            throw new Error("Link is missing mandatory data-href attribute!");
        }

        Utility.blockButton(anchor.id, anchor.dataset.message);

        let csrfParameter = $("meta[name='_csrf_parameter']").attr("content");
        let csrfToken = $("meta[name='_csrf']").attr("content");

        let $form = $('<form>', {
            id: 'postLinkForm',
            action: anchor.dataset.href,
            method: 'post'
        }).append($('<input>', {
            type: 'hidden',
            name: csrfParameter,
            value: csrfToken
        }));

        $('body').append($form);
        $form.submit();
    },

    logout: () => {
        window.fcWidget && window.fcWidget.user.clear();
        document.logoutForm && document.logoutForm.submit();
    },

    isTouchDevice: () => {
        let prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        let mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        let query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    },

    isTheme: (theme) => {
        return $('html').data('theme') === theme;
    },

    blockUI: () => {
        let opts = {
            message:
               '<svg class="spinner" viewBox="0 0 50 50">' +
                    '<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>' +
                '</svg>',
            baseZ: 1080,
            css: {
                width: '80px',
                top: '50%',
                left: '50%',
                border: 'none',
                backgroundColor: 'transparent',
            },
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: .5
            }
        };

        $.blockUI(opts)
    },

    unblockUI: () => {
        $.unblockUI();
    },

    blockButton: (id, message) => {
        let $button = $('#' + id);
        let spinner = '<svg class="spinner spinner-button" viewBox="0 0 50 50">' +
                            '<circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>' +
                        '</svg>';

        if (message !== undefined) {
            Utility.originalMessage = $button.html();
            $button.html(message);
        }

        $button.hasClass('btn') ? $button.addClass('btn-loading') : $button.addClass('link-loading');
        $button.prepend(spinner);

        let opts = {
            message: null,
            baseZ: 1080,
            css: {
                border: 'none'
            },
            overlayCSS: {
                backgroundColor: '#fff',
                opacity: .5
            }
        };

        $.blockUI(opts)
    },

    unblockButton: (id) => {
        let $button = $('#' + id);

        $button.removeClass('btn-loading');
        $button.find('.spinner').remove();

        if (Utility.originalMessage !== '') {
            $button.html(Utility.originalMessage);
        }

        $.unblockUI();
    },

    initFormSubmitBlockUI: () => {
        $('form').on('submit', function () {
            if ($(this).data('disable-blockui')) return;

            if ($(this).hasClass('needs-validation')) {
               if (this.checkValidity()) {
                   Utility.blockUI();
               }
            } else {
                Utility.blockUI();
            }
        });
    },

    formatCommaToDot: (number) => {
        number = Utility.stripWhitespaces(number);
        if (number.indexOf(',') > -1) {
            let parts = number.split(',');
            return parts.slice(0, -1).join('') + '.' + parts.slice(-1);
        }
        return number;
    },

    formatDotToComma: (number) => {
        number = Utility.stripWhitespaces(number);
        if (number.indexOf('.') > -1) {
            let parts = number.split('.');
            return parts.slice(0, -1).join('') + ',' + parts.slice(-1);
        }
        return number;
    },

    stripWhitespaces: (number) => {
        return number.replace(/\s+/g,'');
    },

    formatCurrency: (number, decimalPlaces) => {
        return number.toFixed(decimalPlaces).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },

    storageAvailable: (type) => {
        let storage;
        try {
            storage = window[type];
            let x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && (
                    e.code === 22 ||
                    e.code === 1014 ||
                    e.name === 'QuotaExceededError' ||
                    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
                (storage && storage.length !== 0);
        }
    },

    debounce: (fn, ms) => {
        let timer = 0
        return function (...args) {
            clearTimeout(timer)
            timer = setTimeout(fn.bind(this, ...args), ms === undefined ? 300 : ms)
        }
    },

    fadeAndRemove: (e) => {
        let $element = $(e.currentTarget),
            time = 500;

        if ($element.data('hideElementId')) {
            $element = $(`#${$element.data('hideElementId')}`)
        }

        if (typeof e.data !== 'undefined') {
            time = e.data.time;
        }

        $element.fadeOut(time, () => $element.remove());
    },

    stringFormat: () => {
        if (!String.format) {
            String.format = (format, ...a) => {
                return format.replace(/{(\d+)}/g, (match, number) => {
                    return typeof a[number] != 'undefined' ? a[number] : match;
                });
            };
        }
    },

    getCookieValue: (name) => {
        let cookie = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (cookie) {
            return cookie[2];
        }
    },
};

export default Utility;
